import * as types from '../actions/types'


const siteReducer = (state = {}, action) => {
    switch(action.type) {
        case types.TOGGLE_MENU:
            let menuOpen = true;

            if (state.menuOpen && state.menuOpen === true) {
                menuOpen = false;
            }

            if (action.status === false || action.status === true) {
                menuOpen = action.status;
            }

            return { ...state, menuOpen: menuOpen };

        case types.FETCH_SITEOPTIONS_SUCCESS:

            return { ...state, options: action.site.options };
        default:
            return state;
    }
}

export default siteReducer;


// WEBPACK FOOTER //
// ./src/reducers/siteReducer.js